import React from 'react'
import './styles/preload.css';
const Preload = () => {
    return (
        <div>
            <div className="preload" >
                <h1>Musify</h1></div>
        </div>
    )
}

export default Preload;
